<div class="search-box-container">
  <i class="fa fa-search search-icon"></i>

  <input #searchInput
         type="text"
         class="search-input"
         [placeholder]="placeholder"
         [formControl]="searchControl" />

  <i class="fa fa-times clear-icon" *ngIf="showClear" (click)="clear()"></i>
</div>
